import { Component, ViewEncapsulation } from '@angular/core';
import { Route } from '@xpo-ltl/sdk-cityoperations';
import { ICellRendererAngularComp } from 'ag-grid-angular';

export interface RowMouseOverResponse {
  metrics: any;
  route: Route;
  routeInstId: number;
  tripDsrName: string;
}

@Component({
  selector: 'pnd-action-link-cell-renderer',
  templateUrl: './action-link-cell-renderer.html',
  styleUrls: ['./action-link-cell-renderer.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pnd-ActionLinkCellRenderer' },
})
export class ActionLinkCellRendererComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  mouseOverFunction(clickEvent: MouseEvent): void {
    if (this.params.onHover) {
      const isUnfocus = clickEvent.type === 'mouseout';
      this.params.onHover({ focusedRow: this.params.data, unFocus: isUnfocus });
      clickEvent.stopImmediatePropagation(); // Prevents selecting the row when link clicked.
    }
  }

  onClickFunction(clickEvent: any): void {
    if (this.params.onClick) {
      this.params.onClick(this.params.data);
      clickEvent.stopImmediatePropagation();
    }
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
